module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/schnurrbart-7b506ece8657ab63e95c0dd3f763254e.svg";